<template>
  <div>
    <div class="">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>

      <div class="container-fluid">
        <!-- <div class="card">
          <div class="card-body">
            <form @submit.prevent="onFilter" class="form-inline">
              <div style="margin:1px 3px 1px 3px;" class="form-group">
                <label
                  ><b>{{ $t("start-date") }}:</b>&nbsp;</label
                >
                <input
                  type="date"
                  name="date1"
                  class="form-control"
                  v-model="startdate"
                  :max="nowDate"
                />
              </div>

              <div style="margin:1px 3px 1px 3px;" class="form-group">
                <label
                  ><b>{{ $t("end-date") }}:</b>&nbsp;</label
                >
                <input
                  type="date"
                  name="date2"
                  class="form-control"
                  v-model="enddate"
                  :max="nowDate"
                />
              </div>

              <div style="margin:1px 3px 1px 3px;">
                <button type="submit" class="btn btn-primary mr-2">
                  {{ $t("filter") }}
                </button>
              </div>
            </form>
          </div>
        </div> -->
        <div
          v-if="mssg"
          align="center"
          class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
        >
          <p class="alert-close mb-0">
            {{ mssg }}
          </p>
        </div>

        <div v-if="walletHistory.data" class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <WalletHistoryTable
                  :stats="sorteddevices"
                  :paginationMeta="paginationMeta"
                  @pageChange="pageChange"
                  @doSearch="doSearch"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import WalletHistoryTable from "../../components/WalletHistoryTable.vue";

export default {
  name: "WalletHistory",
  components: {
    Loading,
    WalletHistoryTable,
  },
  data() {
    return {
      condition: "all",
      isLoading: true,
      fullPage: true,
      devicesclone: [],
      sorteddevices: [],
      startdate: "",
      starttime: "00:00",
      enddate: "",
      endtime: "23:59",
      mssg: "",
      nowDate: new Date().toISOString().slice(0, 10),
    };
  },
  mounted() {
    const params = {
      limit: 10,
      page: 1,
    };
    this.getpurchasehistory(params).then(() => {
      this.devicesclone = this.walletHistory.data;
      this.sorteddevices = this.walletHistory.data;
      this.isLoading = false;
    });
  },
  beforeRouteLeave(to, from, next) {
    // introJs().exit();
    next();
  },
  computed: {
    ...mapGetters(["walletHistory", "filteredPurchaseHistory"]),
    paginationMeta() {
      return this.walletHistory.meta;
    },
  },
  methods: {
    ...mapActions(["getpurchasehistory", "getFilteredPurchaseHistory"]),
    startIntroJs() {
      // introJs().start();
    },
    getHistory(params) {
      this.isLoading = true;
      this.getpurchasehistory(params).then(() => {
        this.devicesclone = this.walletHistory.data;
        this.sorteddevices = this.walletHistory.data;
        this.isLoading = false;
      });
    },

    initialiseReport(period) {
      this.getpurchasehistory(period)
        .then(() => {
          this.sorteddevices = this.filteredPurchaseHistory;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },

    onFilter() {
      // this.mssg = '';
      if (this.mssg !== "") return;
      if (this.startdate && this.enddate) {
        this.isLoading = true;
        let period = {
          start: `${this.startdate.replace(/-/g, "/")} ${this.starttime}`,
          end: `${this.enddate.replace(/-/g, "/")} ${this.endtime}`,
        };
        this.initialiseReport(period);
      } else {
        this.mssg = this.$t("pls_sel");
      }
    },
    doSearch(param, searchQuery) {
      let params = {
        ...param,
        keyword: searchQuery,
      };

      this.getHistory(params);
    },
    pageChange(params) {
      this.isLoading = true;
      this.getHistory(params);
    },
  },
  watch: {
    startdate: {
      handler: function() {
        if (this.startdate !== "") this.mssg = "";
        this.enddate = moment(this.enddate).format("YYYY-MM-DD");
        this.startdate = moment(this.startdate).format("YYYY-MM-DD");
        let comparedDate = new Date(this.enddate);
        let comparedStart = new Date(this.startdate);
        if (comparedStart > comparedDate) {
          this.mssg = this.$t("start_cannot");
        } else {
          this.mssg = "";
        }
      },
    },
    enddate: {
      handler: function() {
        if (
          this.startdate !== "Invalid date" &&
          this.enddate !== "Invalid date"
        ) {
          if (this.startdate !== "") this.mssg = "";
          this.enddate = moment(this.enddate).format("YYYY-MM-DD");
          this.startdate = moment(this.startdate).format("YYYY-MM-DD");
          let comparedDate = new Date(this.enddate);
          let comparedStart = new Date(this.startdate);
          console.log(comparedStart > comparedDate);
          if (comparedStart > comparedDate) {
            this.mssg = this.$t("start_cannot");
          } else {
            this.mssg = "";
          }
        }
      },
    },
    walletHistory: {
      handler: function() {
        this.sorteddevices = this.walletHistory.data;
        this.devicesclone = this.walletHistory.data;
      },
    },
  },
};
</script>
<style scoped>
.introjs {
  position: fixed;
  top: 0.3rem;
  right: 12rem;
  z-index: 60;
}
@media (max-width: 991px) {
  .introjs {
    display: none !important;
  }
}
</style>
<i18n>
{
	"en": {
		"pls_sel": "Please select a period to view",
		"start_cannot": "Start date cannot be later than End date"
	},
	"es": {
		"pls_sel": "Seleccione un período para ver",
		"start_cannot": "La fecha de inicio no puede ser posterior a la fecha de finalización"
	},
	"fr": {
		"pls_sel": "Veuillez sélectionner une période pour afficher",
		"start_cannot": "La date de début ne peut pas être postérieure à la date de fin"
	},
	"sw": {
		"pls_sel": "Tafadhali chagua kipindi cha kutazama",
		"start_cannot": "Tarehe ya kuanza haiwezi kuwa baada ya Tarehe ya Mwisho"
	}
}
</i18n>
